import { handleActions } from 'redux-actions'
import {
  changeMouseCursor,
  notifyCapturingStatusChanged,
  notifySendInputStatusChanged,
  hideSendInputNotification,
  videoStreamUnmuted,
  videoStreamMuted,
  screenSharing,
} from './../actions/onDemand'

const initialState = {
  capturingSuspended: false,
  showSendInputDisallowed: false,
  screenSharing: false,
  videoStreamMuted: true,
  streamNotStarted: true,
  cursor: {
    hotspotX: 0,
    hotspotY: 0,
    cursorImage: undefined
  }
}

export const ondemandReducer = handleActions({
  [changeMouseCursor] (prevState, action) {

    return {
      ...prevState,
      cursor: { ...action.payload }
    }
  },
  [notifyCapturingStatusChanged] (prevState, action) {

    return {
      ...prevState,
      capturingSuspended: action.payload
    }
  },
  [notifySendInputStatusChanged] (prevState, action) {

    return {
      ...prevState,
      showSendInputDisallowed: action.payload
    }
  },
  [hideSendInputNotification] (prevState) {

    return {
      ...prevState,
      showSendInputDisallowed: false
    }
  },
  [videoStreamUnmuted] (prevState) {
    return {
      ...prevState,
      videoStreamMuted: false,
      streamNotStarted: false,
    }
  },
  [videoStreamMuted] (prevState) {
    return {
      ...prevState,
      videoStreamMuted: true,
    }
  },
  [screenSharing] (prevState, { payload: active }) {
    return {
      ...prevState,
      screenSharing: Boolean(active),
      streamNotStarted: active ? false : prevState.streamNotStarted,
    }
  },
}, initialState)
